import { createFileRoute } from "@tanstack/react-router";
import StillLookingForDepressionHelpPage from "@/pages/articles/StillLookingForDepressionHelpPage";
export const Route = createFileRoute("/still-looking-for-depression-help")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Still Looking for Depression Help? There Is New Hope | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "If antidepressants and therapy haven't worked, you're not out of options. Discover TMS, SPRAVATO®, Ketamine, and SAINT®—advanced treatments for resistant.",
        },
        {
          property: "og:title",
          content:
            "Still Looking for Depression Help? There Is New Hope | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "If antidepressants and therapy haven't worked, you're not out of options. Discover TMS, SPRAVATO®, Ketamine, and SAINT®—advanced treatments for resistant.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/still-looking-for-depression-help",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/still-looking-for-depression-help",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <StillLookingForDepressionHelpPage />;
}
